module.exports = __webpack_public_path__ + "_help.html";